export const navigation = {
  support: {
    question: "Besoin d'aide ?",
    whatsappCta: "Écrivez-nous sur WhatsApp",
  },
  alt: {
    whatsapp: "Icône WhatsApp",
    logo: "Logo du tableau de bord",
  },
};
